import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sun, Moon } from "lucide-react";
import { Logo } from "../landing/Logo";
import { scrollToId } from "../landing/Navbar";
import { useAuth } from "../../contexts/AuthContext";

const ThemeToggle = () => {
  const [light, setLight] = useState(() => localStorage.getItem("sb_theme") === "light");
  useEffect(() => {
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem("sb_theme", light ? "light" : "dark");
  }, [light]);
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setLight((l) => !l)}
      aria-label="Toggle light mode"
      className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slate-300 transition-colors hover:border-[#22C55E]/60 hover:text-[#22C55E]"
    >
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
};

const DOCK = [
  { icon: "🏠", label: "Home", href: "#top" },
  { icon: "🧑‍🤝‍🧑", label: "Community", href: "#communities" },
  { icon: "🎥", label: "Reels", href: "#reels" },
  { icon: "🛍", label: "Shop", href: "#shopbite" },
  { icon: "👤", label: "Profile", href: "#claim" },
];

export const BiteDock = () => {
  const { user } = useAuth();
  return (
  <>
    <header className="fixed inset-x-0 top-4 z-50 mx-auto flex w-[calc(100%-2rem)] max-w-3xl items-center justify-between rounded-full border border-white/10 bg-[#09090B]/70 py-2.5 pl-4 pr-2.5 backdrop-blur-2xl">
      <a href="#top" onClick={scrollToId("#top")} data-testid="bite-logo" className="flex items-center gap-2">
        <Logo className="h-8 w-8" />
        <span className="font-display text-base font-extrabold tracking-tight text-white">
          FUN<span className="text-[#06B6D4]">Z</span>
        </span>
      </a>
      <div className="flex items-center gap-2">
        <ThemeToggle />
        {user ? (
          <Link
            to="/app"
            data-testid="nav-account"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-[#7C3AED] to-[#06B6D4] font-display text-sm font-black text-white"
            title="Open my FUNZ web app"
          >
            {(user.name || user.email)[0].toUpperCase()}
          </Link>
        ) : (
          <Link
            to="/login"
            data-testid="nav-login"
            className="rounded-full border border-white/15 px-5 py-2 font-display text-xs font-bold uppercase tracking-wider text-slate-200 transition-colors hover:border-[#06B6D4]/60 hover:text-white"
          >
            Log In
          </Link>
        )}
        <button
          data-testid="bite-top-cta"
          onClick={scrollToId("#claim")}
          className="hidden rounded-full bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] px-5 py-2 font-display text-xs font-bold uppercase tracking-wider text-white sm:block"
        >
          Get Started
        </button>
      </div>
    </header>

    <nav
      data-testid="floating-dock"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/10 bg-[#09090B]/70 px-2 py-2 shadow-[0_20px_60px_-15px_rgba(108,99,255,0.5)] backdrop-blur-2xl"
    >
      {DOCK.map((d) => (
        <a
          key={d.label}
          href={d.href}
          data-testid={`dock-${d.label.toLowerCase()}`}
          onClick={scrollToId(d.href)}
          className="group flex flex-col items-center gap-0.5 rounded-full px-3.5 py-1.5 transition-all duration-300 hover:bg-white/10 sm:px-5"
        >
          <span className="text-lg transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:scale-125">
            {d.icon}
          </span>
          <span className="text-[9px] font-semibold uppercase tracking-wider text-slate-400 group-hover:text-white">
            {d.label}
          </span>
        </a>
      ))}
    </nav>
  </>
  );
};
